import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/pickyGoblins/data/constants';

const initState = { currentScreen: SCREENS.PROGRESS };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    case REDUX_ACTIONS.START_LEVEL:
      if (payload.isHelpScreen) {
        return { currentScreen: SCREENS.REPEAT_ONBOARDING };
      }
      return { currentScreen: payload.hasSeenOnboarding ? SCREENS.STANDARD_VIEW : SCREENS.LEVEL_INTRO };

    default:
      return state;
  }
};

export default screenReducer;
